import { EmailConfirmationLogo } from '@assets/icons/EmailConfirmationLogo';
import { TelagriLogo } from '@assets/icons/TelagriLogo';
import { AuthPepper } from '@features/AuthPaper';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import Button from '@mui/material/Button/Button';
import React from 'react';

interface EmailConfirmationProps {
	checkEmailText: string;
	emailSuccessText: string;
	checkEmailVerifyText: string;
	emailLoadText: string;
	emailIssueText: string;
	resendEmailText: string;
	goBackLoginText: string;
	checkEmailClassName?: string;
	goBackLoginClassName?: string;
	showArrow?: boolean;
	[key: string]: any;
}

export const EmailConfirmation: React.FC<EmailConfirmationProps> = ({
	checkEmailText,
	emailSuccessText,
	checkEmailVerifyText,
	emailLoadText,
	emailIssueText,
	resendEmailText,
	goBackLoginText,
	checkEmailClassName = '',
	goBackLoginClassName = '',
	showArrow = false,
	...props
}) => {
	const { navigateWithLanguage } = useLanguageNavigate();

	return (
		<AuthPepper {...props}>
			<div className="flex flex-col items-center justify-center px-4 sm:px-6 lg:px-0 max-sm:px-0 max-sm:my-[65px]">
				<div
					className="mb-[95px] max-sm:mb-[40px] cursor-pointer w-[282px] h-[61px] max-sm:w-[211px] max-sm:h-[45px]"
					onClick={() => navigateWithLanguage('/login')}
				>
					<TelagriLogo />
				</div>
				<div className="mb-[76px] flex flex-col sm:flex-row gap-[45px] items-center justify-center text-center sm:text-left max-sm:gap-[30px] max-sm:mb-[30px]">
					<div className="flex justify-center items-center mb-4 sm:mb-0">
						<EmailConfirmationLogo />
					</div>
					<div className="flex flex-col">
						<h2
							className={`roboto-bold text-xl sm:text-2xl font-semibold mb-2 ${checkEmailClassName}`}
						>
							{checkEmailText} {showArrow && '→'}
						</h2>
						<p className="text-sm sm:text-base !text-secondary roboto-regular">
							{/* {emailSuccessText} */}
							<br />
							{checkEmailVerifyText}
						</p>
					</div>
				</div>
				<div className="flex flex-col">
					<div className="w-screen bg-[#FFF8F4] p-[40px]">
						<div className="max-w-screen-lg mx-auto rounded-lg flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-10">
							<p className="text-xs sm:text-sm roboto-regular text-gray-500 text-center sm:text-left">
								{emailLoadText}
								<br />
								{emailIssueText}
							</p>
							<Button
								onClick={() => navigateWithLanguage('/login/reset')}
								className="!bg-white !text-base !text-xs !font-[700]"
								variant="contained"
							>
								{resendEmailText}
							</Button>
						</div>
					</div>
					<div className="w-screen flex justify-center items-center mt-[50px]">
						<Button
							onClick={() => navigateWithLanguage('/login/reset-password')}
							className={`w-full text-primary size-[16px] !font-[700] underline capitalize mt-[50px] max-sm:mt-[10px] !bg-transparent  ${goBackLoginClassName}`}
							variant="text"
							size="small"
						>
							{goBackLoginText}
						</Button>
					</div>
				</div>
			</div>
		</AuthPepper>
	);
};
